module.exports = "pegasus/assets/theme2/small/4.jpg";